import React, { FC } from 'react';
import styled from 'styled-components';

import { colors, DATES } from '../constants';

import { DropDown } from './DropDown';

interface DateDropDownProps {
  name: string;
  value: string;
  label: string;
  onChange:
    | ((e: React.ChangeEvent<any>) => void)
    | (((e: React.ChangeEvent<any>) => void) & ((text: string) => void))
    | (() => undefined);
  formatSelection: () => string;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  onBlur?: (e: React.FocusEvent<any>) => void;
}

const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 25rem;
  margin: 0 auto 1rem;
  border-radius: 0.125rem;
  .dropdown-label {
    // Replace Label in DropDown component with FormattedSelection
    display: none;
  }
`;
Container.displayName = 'Container';

// Custom masking element formats the selected value within the select input
const FormattedSelection = styled.p`
  position: absolute;
  top: 0;
  left: 0;
  height: 3.25rem;
  width: 85%;
  margin: 0.125rem 0 0.125rem 0.25rem;
  padding: 0 0 0 0.6875rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: 1.25rem;
  font-size: 1rem;
  text-align: left;
  color: ${colors.TEXT_LABEL};
  background-color: ${colors.DROPDOWN_BACKGROUND};
  pointer-events: none;
`;
FormattedSelection.displayName = 'FormattedSelection';

export const DateDropDown: FC<DateDropDownProps> = ({
  name,
  value,
  label,
  onChange,
  formatSelection,
  error,
  touched,
  disabled,
  onBlur,
}) => (
  <Container>
    <DropDown
      name={name}
      value={value}
      label={label}
      options={DATES}
      error={error}
      touched={touched}
      disabled={disabled}
      onChange={onChange}
      onBlur={onBlur}
      slide={false}
      required
    />
    <FormattedSelection>{formatSelection()}</FormattedSelection>
  </Container>
);

DateDropDown.defaultProps = {
  disabled: false,
  error: undefined,
  touched: undefined,
  onBlur: () => {},
};
